import {createPlanetTheme} from '@apps-common/ui-theme/Themes';

export const theme = createPlanetTheme({
  colorScheme: 'dark',
  extendedConfig: {
    components: {
      '& .MuiFormControlLabel-root': {
        styleOverrides: {
          label: {
            fontSize: 14,
          },
        },
      },
    },
  },
});
